import { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { OrdersBoard } from "@/components/store/orders-board"
import { ProductsTab } from "@/components/store/products-tab"
import { StoreSettingsTab } from "@/components/store/store-settings-tab"
import { useStore, useStoreOrders } from "@/api/store"
import { ShoppingBag, Package, Settings, PlusIcon } from "lucide-react"

export default function StorePage() {
  const { data: store } = useStore()
  const { data: orders = [] } = useStoreOrders()

  const [tab, setTab] = useState("orders")
  const [triggerAddProduct, setTriggerAddProduct] = useState(false)

  const handleAddProduct = () => {
    setTab("products")
    setTriggerAddProduct(true)
  }

  const entryStatusKey =
    store?.entryStatusKey ??
    store?.orderWorkflow?.find((stage) => !stage.isTerminal)?.key
  const pendingOrdersCount = entryStatusKey
    ? orders.filter((order) => order.status === entryStatusKey).length
    : 0

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">{store?.name ?? "Store"}</h1>
          {store && !store.enabled && (
            <Badge variant="secondary" className="mt-1">Disabled</Badge>
          )}
        </div>
        <Button onClick={handleAddProduct}>
          <PlusIcon className="h-4 w-4 mr-2" />
          Add Product
        </Button>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="orders" className="flex items-center gap-2">
            <ShoppingBag className="h-4 w-4" />
            Orders
            {pendingOrdersCount > 0 && (
              <Badge className="ml-1 bg-destructive text-destructive-foreground text-xs px-1.5 py-0">
                {pendingOrdersCount}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="products" className="flex items-center gap-2">
            <Package className="h-4 w-4" />
            Products
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="orders" className="mt-6">
          <OrdersBoard />
        </TabsContent>

        <TabsContent value="products" className="mt-6">
          <ProductsTab
            openAddDialog={triggerAddProduct}
            onAddDialogHandled={() => setTriggerAddProduct(false)}
          />
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          <StoreSettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
